exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarProveedor .h2_title[data-v-1f62b378] {\r\n  font-weight: normal;\n}\n.btn-grabar[data-v-1f62b378] {\r\n  background-color: #ff6c00 !important;\r\n  color: white !important;\n}\n.align-bottom[data-v-1f62b378] {\r\n  -ms-flex-item-align: end;\r\n      align-self: flex-end;\r\n  /* Alinea el elemento al final del contenedor verticalmente */\n}\n#gridComponent[data-v-1f62b378] {\r\n  width: 100%;\r\n  font-family: 'Asap', sans-serif;\n}\r\n", ""]);

// exports
